import { Pipe, PipeTransform } from '@angular/core';
import { Utils } from '../utils.class';

@Pipe({
    name: 'weekTooltip',
    standalone: false,
})
export class WeekTooltipPipe implements PipeTransform {
    transform(week: { dates: string[] }): string {
        if (!week || !week.dates || week.dates.length < 7) {
            return '';
        }

        const firstDay = new Date(week.dates[0]);
        const lastDay = new Date(week.dates[6]);

        const firstStr = Utils.formatDate(firstDay, 'EEE d MMM', 'nl');
        const lastStr = Utils.formatDate(lastDay, 'EEE d MMM', 'nl');

        // Eerste letter hoofdletter maken (Ma ipv ma)
        return `${firstStr.charAt(0).toUpperCase() + firstStr.slice(1)} - ${lastStr.charAt(0).toUpperCase() + lastStr.slice(1)}`;
    }
}
